import React from 'react'

import { styled } from '@mui/material/styles'

import {
  FormatListBulleted as FormatListBulletedIcon,
  FormatListNumbered as FormatListNumberedIcon,
  FormatBold as FormatBoldIcon,
  FormatItalic as FormatItalicIcon,
  FormatUnderlined as FormatUnderlinedIcon,
} from '@mui/icons-material'
import { Icon } from '@mui/material'
import { BLOCK_TYPES, INLINE_STYLES } from './RichTextStylingOptions'

const PREFIX = 'StyleButton'

const classes = {
  icon: `${PREFIX}-icon`,
  labelIcon: `${PREFIX}-labelIcon`,
  button: `${PREFIX}-button`,
  activeButtons: `${PREFIX}-activeButtons`,
}

const Root = styled('span')(() => {
  return {
    [`& .${classes.icon}`]: {
      fontSize: 16,
    },
    [`& .${classes.labelIcon}`]: {
      fontSize: 14,
    },
    [`&.${classes.button}`]: {
      color: '#000',
      cursor: 'pointer',
      marginRight: '16px',
      padding: '2px 0',
      display: 'inline-block',
    },
    [`& .${classes.activeButtons}`]: {
      color: '#5890ff',
      cursor: 'pointer',
      marginRight: '16px',
      padding: '2px 0',
      display: 'inline-block',
    },
  }
})

const StyleButton = props => {
  const { onToggle, style } = props
  let className = classes.button
  if (props.active) {
    className = classes.activeButtons
  }
  const renderIcon = icon => {
    switch (icon) {
      case BLOCK_TYPES.OL.icon:
        return (
          <FormatListNumberedIcon
            className={classes.icon}
          ></FormatListNumberedIcon>
        )
      case BLOCK_TYPES.UL.icon:
        return (
          <FormatListBulletedIcon
            className={classes.icon}
          ></FormatListBulletedIcon>
        )
      case INLINE_STYLES.BOLD.icon:
        return <FormatBoldIcon className={classes.icon}></FormatBoldIcon>
      case INLINE_STYLES.ITALIC.icon:
        return <FormatItalicIcon className={classes.icon}></FormatItalicIcon>
      case INLINE_STYLES.UNDERLINE.icon:
        return (
          <FormatUnderlinedIcon className={classes.icon}></FormatUnderlinedIcon>
        )
      default:
        return <></>
    }
  }
  return (
    <Root className={className} onMouseDown={() => onToggle(style)}>
      {props.icon ? (
        renderIcon(props.icon)
      ) : (
        <Icon className={classes.labelIcon}>{props.label}</Icon>
      )}
    </Root>
  )
}

export default StyleButton
